<template>
  <div class="editor-options-setting-dialog" :class="isBigScreen ? 'bc-setting' : ''">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="内容" name="1" class="padding8">
          <template slot="title">
            内容
            <div v-if="isCXEditor" class="expand-btn" @click.stop="expandClick()"><i class="icon-portal-scale-up"></i>
            </div>
          </template>
          <div class="setting-item clearFloat textArea-wrap">
            <editor v-if="!isCXEditor" id="tinymceEditor" v-model="content" :init="editorInit"></editor>
            <div v-if="isCXEditor" class="multieditor" id="noteEditorContentFix" ref="editEditor" :class="'editor'+ ids.rect_id"></div>
          </div>
        </el-collapse-item>
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item title="背景" name="2">
          <cx-background infoTips="支持上传图片" :background.sync="background" :background="background" imgType="10" />
        </el-collapse-item>
        <el-collapse-item title="边框" name="3">
          <div>
            <div class="content-item verticallyCenter mb8">
              <el-checkbox v-model="showBorder">显示边框</el-checkbox>
            </div>
            <cx-border
              v-if="showBorder"
              :borderWidth.sync="borderWidth"
              :borderStyle.sync="borderStyle"
              :borderColor.sync="borderColor"
              :borderIsThemeColor.sync="borderIsThemeColor"
            />
          </div>
          <div class="content-item mt16">
            <border-radius
              :borderTypeFlag.sync="borderTypeFlag"
              :borderRadius.sync="borderRadius"
              :borderTopLeftRadius.sync="borderTopLeftRadius"
              :borderTopRightRadius.sync="borderTopRightRadius"
              :borderBottomRightRadius.sync="borderBottomRightRadius"
              :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              :sliderMax="paddingMax"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="边距" name="4">
          <cx-padding
            :paddingTypeFlag.sync="textPaddingTypeFlag"
            :padding.sync="padding"
            :paddingTop.sync="paddingTop"
            :paddingRight.sync="paddingRight"
            :paddingBottom.sync="paddingBottom"
            :paddingLeft.sync="paddingLeft"
          />
        </el-collapse-item>
        <el-collapse-item title="更多" name="5">
          <div class="content">
            <div class="verticallyCenter">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <widthAndSizeAndZindex
              :options="options"
              :ids="ids"
              showSetItem="rotate"
              class="mt16"
              v-if="request_prefix !== 'bigScreen'"
            />
            <div class="content-item mt16 verticallyCenter">
              <span class="mr16">溢出</span>
              <text-setting-overflow :overFlowType.sync="textOverFlowType" style="flex: 1"></text-setting-overflow>
            </div>
            <div class="content-item mt16 verticallyCenter">
              <span class="mr16">对齐</span>
              <text-vertical-align-setting :verticalAlign.sync="verticalAlign" style="flex: 1" />
            </div>
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
            <div class="content-item mt16">
              <public-style :options="options" :ids="ids"></public-style>
            </div>
            <div class="content-item mt16 verticallyCenter" v-if="!isCXEditor">
              <el-checkbox v-model="contentHasLimit">字数限制</el-checkbox>
            </div>
            <div v-show="contentHasLimit" class="content-item card mt16">
              <div class="content-item fs14 verticallyCenter count-limit-item">
                <span class="mr16">超出</span>
                <single-input
                  class="size-inp mr8"
                  style="width: 90px; height: 32px"
                  :value.sync="textLimitLines"
                  inputSuffixs="行"
                />
                <span>隐藏</span>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item v-if="request_prefix === 'bigScreen'" title="动画设置" name="6">
          <big-screen-animate-set></big-screen-animate-set>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog title="内容"
               :append-to-body="true"
               :visible="expandDialog"
               custom-class="expandDialog"
               :show-close="false"
               @close="expandDialogCloseFunc"
    >
      <template slot="title">
        <span class="el-dialog__title">内容</span>
        <button type="button" class="el-dialog__headerbtn" @click="expandDialogCloseFunc"><i class="icon-portal-scale-down"></i></button>
      </template>
      <div class="multieditor" id="noteEditorContentFix1"></div>
    </el-dialog>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import TextSettingOverflow from "modules/components/textSettingOverflow"
import tinymce from "tinymce"
import Editor from "@tinymce/tinymce-vue"
import "tinymce/themes/silver/theme"
import "tinymce/icons/default/icons"
import "tinymce/skins/ui/oxide/skin.min.css"
import { withMethodsHistoryCombine } from "utils/revork"
import "tinymce/plugins/link"
import "tinymce/plugins/lists"
import "tinymce/plugins/autolink"
import "../../../../public/tinymce/plugins/letterspacing/idnex"
import iconUrl from "../../../../public/tinymce/icons/icons"
import publicStyle from "publicSetting/publicStyle.vue"
export default withMethodsHistoryCombine({
  name: "editor-options-setting",
  components: { controlWidthAndSizeAndZindex, widthAndSizeAndZindex, editor: Editor, TextSettingOverflow, publicStyle },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1"],
      hoverOpt: [],
      this1: this,
      activeType: 1,
      sliderMax: 360,
      paddingMax: 200,
      editorInit: {
        selector: "#tinymceEditor",
        language: "zh-Hans",
        language_url: "./tinymce/skins/langs/zh-Hans.js",
        icons_url: iconUrl,
        icons: "christmas",
        height: 400,
        plugins: ["link", "letterspacing"],
        extended_valid_elements: "a[target|href]",
        menubar: "", //去掉第一排的文件等菜单
        toolbar: [
          "styleselect | fontselect | fontsizeselect |  forecolor backcolor | lineheight | letterspacing |bold italic underline | alignleft aligncenter alignright alignjustify"
        ],
        fontsize_formats:
          "12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px 38px 40px 42px 44px 46px 48px 50px 52px 54px 56px 58px 60px 62px 64px 66px 68px 70px 72px 74px 76px 78px 80px 82px",
        font_formats:
          "默认字体=PingFang SC 微软雅黑=Microsoft YaHei;方正仿宋_GBK=方正仿宋_GBK;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei;Times New Roman=Times New Roman;",
        valid_elements: "p[style],strong,em,span[style],a[href],ul,ol,li,br",
        style_formats: [
          { title: "标题1", block: "p", styles: { "font-size": "24px", "font-weight": "600", "line-height": "1.4" } },
          { title: "标题2", block: "p", styles: { "font-size": "20px", "font-weight": "600", "line-height": "1.4" } },
          { title: "标题3", block: "p", styles: { "font-size": "18px", "font-weight": "600", "line-height": "1.4" } },
          { title: "标题4", block: "p", styles: { "font-size": "16px", "font-weight": "600", "line-height": "1.4" } },
          { title: "正文", block: "p", styles: { "font-size": "14px", "font-weight": "400", "line-height": "1.6" } }
        ],
        remove_trailing_brs: false,
        powerpaste_word_import: "clean",
        powerpaste_html_import: "clean",
        letterspacing: "-0.08em -0.04em 0 0.04em 0.08em",
        forced_root_block: '',
        trim_span_elements: false,
      },
      // 是否能够更新富文本内容
      shouldUpdateEditData: true,
      isCXEditor: true,  //是否使用超星笔记编辑器
      toolbars: [
        'Undo', //撤销
        'Redo', //重做
        'paragraph',//段落与标题
        '|',
        'fontfamily',//字体
        'fontsize',//字号
        'bold',//加粗
        'italic',//斜体
        'underline',//下划线
        'strikethrough',//删除线
        'forecolor',//字体颜色
        'backcolor',//字体背景色
        'insertunorderedlist',//无序列表
        'insertorderedlist',//有序列表
        // 'justify',//字体对齐
        'indent',//缩进
        'lineheight',//行间距
        'horizontal',//分割线
        'insertcode',//代码块
        'inserttable',//插入表格
        'attachment',//附件
        'insertimage',//图片
        'link',//链接
      ],
      expandDialog: false,
      contentPop: "",
      firstOpen: true,
    }
  },
  created() {
    if(this.ids.uid){  //单元格内的富文本沿用之前的逻辑，不采用笔记编辑器
      this.isCXEditor = false
    }
    if(this.isCXEditor){
      /* 每个页面只能调用一次!!!!!!!! */
      setTimeout(()=>{
        // 超星笔记编辑页 加载配置文件方法
        MultiEditor.init("edit") //加载配置文件，编辑页传参 edit，详情页传参 detail
      }, 1000)
    }
  },
  watch:{
    content: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.ids.hasOwnProperty("rect_id") && newVal !== oldVal) {
          let ids1 = "editor" + this.ids.rect_id
          let classArr = this.$refs.editEditor.className
          if(classArr.length > 0 && classArr.indexOf(ids1) === -1){
          // 同类型组件切换：富文本组件，需要重新初始化富文本内容
          //  限制：仅限单独的富文本组件
            MultiEditor.setRichText('noteEditorContentFix', newVal)
          }
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      tinymce.init({})
      if(this.isCXEditor){
        setTimeout(()=>{
          this.initEditor1()
        }, 1000)
      }
    })
  },
  // 在卸载的时候，需要将富文本内容更新开关关闭，因为它会错误的把下个activate状态的元素内容给修改
  beforeDestroy() {
    this.shouldUpdateEditData = false
    if(this.isCXEditor){
      MultiEditor.destoryEditor('noteEditorContentFix')
      MultiEditor.destoryEditor('noteEditorContentFix1')
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    hasHandleNbsp(){
      return this.options.hasHandleNbsp
    },
    content: {
      get() {
        let content = this.options.content
        let arrEntities
        if(this.hasHandleNbsp){
          arrEntities = { lt: "<", gt: ">", bsp: " ",amp: "&", qquot: '"', quot: '"' }
          content = content.replace(/&(lt|gt|bsp|amp|qquot|quot);/gi, function (all, t) {
            return arrEntities[t]
          })
        }else{
          arrEntities ={ lt: "<", gt: ">", nbsp: " ", amp: "&", qquot: '"', quot: '"' }
          content = content.replace(/&(lt|gt|nbsp|amp|qquot|quot);/gi, function (all, t) {
            return arrEntities[t]
          })
        }
        // let arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", qquot: '"', quot: '"' }
        // content = content.replace(/&(lt|gt|nbsp|amp|qquot|quot);/gi, function (all, t) {
        //   return arrEntities[t]
        // })
        return content
      },
      set(newVal) {
        if (this.shouldUpdateEditData) {
          let val = newVal.replace(/[<>&" ]/g, function (c) {
            return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&qquot;", " ": "&bsp;" }[c]
          })
          this.$changeOptionsEV(true, "hasHandleNbsp", false, undefined, this.ids)
          this.$changeOptionsEV(true, "handleDefaultMargin", false, undefined, this.ids)
          this.$changeOptionsEV(val, "content", false)
        }
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    opacity: {
      get() {
        // return this.options.opacity || 100
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        newVal !== this.opacity && this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowColor", "boxShadowColor", ["rgba(255,255,255,1)"])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowH", "boxShadowH", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowV", "boxShadowV", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowBlur", "boxShadowBlur", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowSpread", "boxShadowSpread", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    // 边距
    textPaddingTypeFlag: {
      get() {
        let defaultType = 2
        return this.checkAndSetPrimaryVal(this.options, "textPaddingTypeFlag", "textPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        // return this.options.padding || 0
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        // return this.options.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderRadius", "borderRadius", this.borderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
              "borderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopLeftRadius", "borderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopRightRadius", "borderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomRightRadius", "borderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomLeftRadius", "borderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if(this.options.showBorder === undefined){
          if(this.options.borderWidth){
            showBorder = true
          }else{
            showBorder = false
          }
        }else{
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    // 描边
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderColor", "borderColor", "rgba(255,255,255,0)")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderStyle", "borderStyle", "solid")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    textOverFlowType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "textOverFlowType", "textOverFlowType", "visible")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textOverFlowType", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    textLimitLines: {
      get() {
        return this.options.textLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },
    verticalAlign:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "verticalAlign", "verticalAlign", "top")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "verticalAlign", false)
        /**/
      }
    },
  },
  methods: {
    switchHandle(type) {
      this.activeType = type
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    initEditor1(type){
      let _this = this
      let contentStr = _this.content
      let idStr = 'noteEditorContentFix'
      if(type === 2){
        idStr = 'noteEditorContentFix1'
        contentStr = _this.contentPop
      }
      MultiEditor.initEditor({
        'editorid': idStr,
        'content':  contentStr,
        'editorheight': 300,
        'wordcount': true,
        'toolbars': _this.toolbars //工具栏配置，可不传，不传就是显示全部工具栏
      }, function () {//编辑器加载完成后调用
        console.log('编辑器加载完成');
      }, function (msg) {//内容变化回调
        console.log('内容变化回调', msg)
        if(type === 2){
          _this.contentPop = msg
        }else{
          _this.content = msg
        }
      });
    },
    expandClick(){
      let _this = this
      this.contentPop = this.content
      this.expandDialog = true
      setTimeout(()=>{
        if(this.firstOpen){
          this.initEditor1(2)
          this.firstOpen = false
        }else{
          MultiEditor.setRichText('noteEditorContentFix1',"")
          setTimeout(()=>{
            MultiEditor.setRichText('noteEditorContentFix1',_this.content)
          }, 300)
        }
      }, 300)
    },
    expandDialogCloseFunc(){
      let _this = this
      this.content = this.contentPop
      setTimeout(()=>{
        MultiEditor.setRichText('noteEditorContentFix', "")
        setTimeout(()=>{
          MultiEditor.setRichText('noteEditorContentFix', _this.contentPop)
        }, 300)
      }, 300)
      this.expandDialog = false
    },
  }
})
</script>

<style scoped lang="scss">
::v-deep .tox-tinymce {
  z-index: 9999;
  display: flex !important;
  border: 1px solid #e9e9e9;
}
p {
  margin-bottom: 0;
}
.paddingl0 {
  padding-left: 0;
}

::v-deep .boxshadow-wrap {
  z-index: 1002;
}
::v-deep .boxshadow-wrap .ml24 {
  margin-left: 2px;
  margin-right: 10px;
}
::v-deep.font-arrangement-btn {
  background: #f0f0f0;
}
.bc-setting ::v-deep.font-arrangement-btn {
  padding: 3px;
  border: none;
}
.lightColor444 {
  color: rgba(0, 0, 0, 0.4);
}
.deepColor444 {
  color: rgba(255, 255, 255, 0.4);
}
::v-deep .tox .tox-tbtn--select {
  width: 72px;
}

.toolbar .padding8 ::v-deep .el-collapse-item__content {
  padding: 8px;
}
::v-deep .tox:not([dir="rtl"]) .tox-toolbar__group:not(:last-of-type) {
  border-right: none;
  position: relative;
}
::v-deep .tox:not([dir="rtl"]) .tox-toolbar__group:not(:last-of-type)::after {
  content: "";
  position: absolute;
  right: 0;
  display: block;
  width: 1px;
  height: 18px;
  background: #e8e8e8;
}
::v-deep .tox .tox-toolbar .tox-toolbar__group:nth-child(1) .tox-tbtn {
  width: 64px;
}
::v-deep .tox .tox-toolbar .tox-toolbar__group:nth-child(2) .tox-tbtn {
  width: 82px;
}
::v-deep .tox .tox-toolbar .tox-toolbar__group:nth-child(3) .tox-tbtn {
  width: 72px;
}
::v-deep .tox .tox-toolbar .tox-toolbar__group:nth-child(3)::after,
::v-deep .tox .tox-toolbar .tox-toolbar__group:nth-child(6)::after {
  width: 0;
}
::v-deep .tox .tox-toolbar .tox-toolbar__group:nth-child(4) .tox-split-button {
  width: 40px;
  height: 28px;
  margin: 0 1px;
}
::v-deep .tox .tox-toolbar .tox-toolbar__group:nth-child(4) .tox-split-button .tox-tbtn:first-child {
  width: 24px;
}
::v-deep .tox .tox-toolbar .tox-toolbar__group:nth-child(4) .tox-split-button .tox-tbtn {
  margin: 0;
}
::v-deep .tox .tox-toolbar .tox-toolbar__group:nth-child(5) .tox-tbtn {
  width: 70px;
}
::v-deep .tox .tox-toolbar .tox-toolbar__group:nth-child(6) .tox-tbtn {
  width: 66px;
}
::v-deep .tox.tox-tinymce .tox-toolbar__group {
  height: 33px;
}
/*解决火狐上，富文本设置项因为宽度不够，设置项未按照原计划换行*/
.textArea-wrap{
  min-width: 244px;
}
  .expand-btn{
    position: absolute;
    right: 12px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
    width: 24px;
    text-align: center;
    height: 24px;
    line-height: 24px;
  }
</style>
<style>
  #edui_fixedlayer.edui-default,
  .editorMaskDiv{
    z-index: 3001 !important;
  }
  #noteEditorContentFix1 .edui-default .edui-toolbar{
    background-color: #F5F5F5;
  }
</style>
